import { createStyles, keyframes, rem } from '@mantine/core'

export const arrowJump = keyframes({
  '0%': { transform: 'translateX(-2px)' },
  '50%': { transform: 'translateX(2px)' },
  '100%': { transform: 'translateX(-2px)' },
})

export const ctaFlash = keyframes({
  '0%, 5%, 50%, 100%': { backgroundPosition: '0 50%' },
  '35%': { backgroundPosition: '100% 50%' },
})

export default createStyles((theme) => {
  return {
    root: {
      overflow: 'hidden',
      img: {
        objectFit: 'cover',
        width: '100%',
        height: '100%',
      },
    },
    wrapper: {
      position: 'relative',
    },
    heading: {
      position: 'absolute',
      [theme.fn.smallerThan('sm')]: {
        left: rem(16),
        right: rem(16),
        top: rem(16),
        textAlign: 'center',
      },
      [theme.fn.largerThan('sm')]: {
        left: rem(40),
        top: rem(40),
      },
    },
    cta: {
      position: 'absolute',
      [theme.fn.smallerThan('sm')]: {
        left: rem(16),
        // bottom: listBannerLength > 1 ? rem(40) : rem(16),
        right: rem(16),
      },
      [theme.fn.largerThan('sm')]: {
        left: rem(40),
        bottom: rem(40),
      },
    },
    ctaBtn: {
      color: '#fff',
      [theme.fn.smallerThan('sm')]: {
        width: '100%',
      },
    },
    ctaBtnRightIcon: {},
    ctaArrow: {
      animation: `${arrowJump} 0.6s infinite`,
    },
    popoperDropdown: {
      padding: 0,
      border: 0,
    },
    popoperArrow: {
      backgroundColor: theme.colors.yellow[0],
    },
    disclaimer: {
      padding: rem(8),
      border: `1px solid ${theme.colors.yellow[1]}`,
    },
    disclaimerText: { fontSize: rem(12), lineHeight: rem(18) },
  }
})
